import { render, staticRenderFns } from "./FacturaList.vue?vue&type=template&id=003db870"
import script from "./FacturaList.vue?vue&type=script&lang=js"
export * from "./FacturaList.vue?vue&type=script&lang=js"
import style0 from "./FacturaList.vue?vue&type=style&index=0&id=003db870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports